import React from 'react';
import { Button, ButtonColor, IconType } from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';
import { ProjectPermission, useAuthorizationChecker } from 'authorization-scope';
import { ApplyTemplateForm } from 'features/tasks-forms';


export function ApplyTemplateButton(props: {
  projectId: number,
}) {
  const popupManager = usePopupFormManager();

  const { isGranted } = useAuthorizationChecker();

  if (isGranted(ProjectPermission.CREATE_DOCUMENTS)) {
    return (
      <Button
        text="Apply Template"
        iconType={IconType.PLUS}
        color={ButtonColor.GRAY}
        onClick={() => popupManager.openForm(<ApplyTemplateForm projectId={props.projectId} />)}
      />
    );
  }
}
